import React, { useEffect, useState } from "react";
import { Button } from "@vds/buttons";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useSelector, useDispatch } from "react-redux";
import DeviceList from "./DeviceList";
import { Box, Card, CircularProgress, Divider, IconButton, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { clearFilter, fetchDeviceTypesRequest, fetchRequest, updateUI } from "../../store/actions/devices";
import filterBlack from "../../assets/filter black.svg";
import { ResponsivePie } from "@nivo/pie";
import CreateDevice from "./CreateDevice";
import ToastNotification from "../../global/components/ToastNotification";

const DevicesData = () => {
  const [currentTab, setCurrentTab] = useState(1);
  const user = useSelector((state) => state.auth.user);
  const [connectFilter, setConnectFilter] = useState(null);
  const [assetTypeFilter, setAssetTypeFilter] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [isModelVisible, setIsModelVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    deviceId,
    organizationId,
    locationId,
    healthStatus,
    deviceConnectedStatus,
    deviceType,
    activeStatus,
  } = location.state || {
    deviceId: "",
    organizationId: "",
    locationId: "",
    healthStatus: "",
    deviceConnectedStatus: "",
    deviceType: "",
    activeStatus: "",
  };
  const deviceCounts = useSelector((state) => state.devices.deviceCounts);
  const filters = useSelector((state) => state.devices.filters);
  const isLoading = useSelector((state) => state.devices.isLoading);

  useEffect(() => {
    dispatch(
      fetchRequest({
        isLoaded: false,
        healthStatus: healthStatus ? [healthStatus] : [],
        deviceConnectedStatus: deviceConnectedStatus
          ? [deviceConnectedStatus]
          : [],
        deviceName: deviceId || "",
        deviceType: deviceType ? [deviceType] : [],
        activeStatus: activeStatus ? [activeStatus] : [],
        organization:
          location?.state?.organizationId !== undefined
            ? [location?.state?.organizationId]
            : [],
        location:
          location?.state?.location !== undefined
            ? [location?.state?.location]
            : [],
        sort: [
          {
            field: "createdon",
            order: "desc",
          },
        ],
        pagenumber: 0,
        limitnumber: 50,
      })
    );
  }, [
    dispatch,
    deviceId,
    organizationId,
    locationId,
    healthStatus,
    deviceConnectedStatus,
    deviceType,
    activeStatus,
    user?.accountId,
  ]);
const {
    formdata,
    isOpen,
    notification,
  } = useSelector((state) => ({
    formdata: state.devices.ui.formData,
    isOpen: state.devices.ui.formData.isOpen,
    notification: state.devices.ui.notification,
  }));
  useEffect(() => {
    dispatch(clearFilter());
  }, [dispatch, user?.accountId])

  const handleConnectFilterChange = (value) => {
    dispatch(
      fetchRequest({ ...filters, deviceConnectedStatus: [value] || [] })
    );
  };
const handleAddDevice = () => {
    dispatch(fetchDeviceTypesRequest());
    // dispatch(fetchDeviceNamesRequest());
    // dispatch(fetchLocationsRequest());
     dispatch(
    updateUI({
      
      formData: {
        isOpen: true,
      },
    })
  );
  };
   const onExit = () => {
      dispatch(
        updateUI({ isOpen: false })
      );
    };
  const handleHealthStatusFilterChange = (value) => {
    dispatch(fetchRequest({ ...filters, healthStatus: [value] || [] }));
  };
  // const handleTotalFilterChange = (value) => {
  //   dispatch(fetchRequest({ ...filters, healthStatus: value || "", deviceConnectedStatus: value || "" }));
  // };
  const handlePieChartClick = (val) => {
    const data = ["Ok", "Error", "Critical", "Unknown"];
    dispatch(
      fetchRequest({
        ...filters,
        healthStatus:
          val.node.label === "Error" ? ["Critical"] : [val.node.label],
      })
    );
  };
  const handlePieDeviceStatusChartClick = (val) => {
    dispatch(
      fetchRequest({
        ...filters,
        deviceConnectedStatus:
          val.node.label === "Ok" ? ["Unknown"] : [val.node.label],
      })
    );
  };
  const handleClick = (val) => {
    dispatch(
      fetchRequest({ ...filters, healthStatus: [], deviceConnectedStatus: [] })
    );
  };
  const statusData =
    deviceCounts.total > 0
      ? [
        {
          id: "critical",
          label: "Error",
          value: deviceCounts.error,
          color: "#FF8027",
        },
        {
          id: "warning",
          label: "Warning",
          value: deviceCounts.warning,
          color: "#FED60E",
        },
        {
          id: "No alert",
          label: "Ok",
          value: deviceCounts.ok,
          color: " #DCF5E6",
        },
        {
          id: "notification",
          label: "Notification",
          value: deviceCounts.notification,
          color: "#0089EC",
        },
        {
          id: "unknown",
          label: "Unknown",
          value: deviceCounts.severityUnknown,
          color: "#6F7171",
        },
      ].filter((item) => item.value > 0) // Filter out items with 0 count
      : [
        {
          id: "",
          label: "",
          value: 1,
          color: "#D8DADA",
        },
      ];

  const ConnectionData =
    deviceCounts.total > 0
      ? [
        {
          id: "online",
          label: "Online",
          value: deviceCounts.online,
          color: "#E3F2FD",
        },
        {
          id: "offline",
          label: "Offline",
          value: deviceCounts.offline,
          color: "#FF8027",
        },
        {
          id: "unknown",
          label: "Unknown",
          value: deviceCounts.statusUnknown,
          color: "#6F7171",
        },
      ].filter((item) => item.value > 0)
      : [
        {
          id: "",
          label: "",
          value: 1,
          color: "#D8DADA",
        },
      ];
  return (
     <Box
                sx={{
                    minHeight: "65vh",
                    margin: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                }}
            >
              {/* {notification.isActive &&
         (
          <ToastNotification
            type={notification.type}
            message={notification.message}
            description={notification.description}
            duration={1}
            style={notification.style}
          />
        )} */}
                <div
                         style={{
                           display: "flex",
                           flexDirection: "row",
                           justifyContent: "space-between",
                         }}
                       >
                         <h2 className="page-common-heading_tittle">Devices</h2>
                         <div style={{ alignContent: "end" }}>
                           <Button
                             style={{
                               marginTop: "-42px",
                               fontFamily: "VerizonNHGDS",
                               fontWeight: 700,
                               fontSize: "16px",
                               lineHeight: "20px",
                               letterSpacing: "0.5px",
                               textAlign: "center",
                             }}
                             size="large"
                             use="primary"
                             onClick={handleAddDevice}
                           >
                             Add Device
                           </Button>
                         </div>
                       </div>
<Grid2 container spacing={4} sx={{ mt: 3 }}>
  {/* Device Status Card */}
  
  <Grid2 item xs={12} md={6}>
    <Card
      elevation={3}
      sx={{
        backgroundColor: "#FFFFFF",
        padding: 3,
        borderRadius: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 420, // Prevent card bounce
      }}
    >
      <Typography variant="h6" className="font-face-vzw-alert" sx={{ marginBottom: 2, paddingTop: 1 }}>
        DEVICE STATUS
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 15,
          height: 250, // fixed height to align with other card
          minHeight: 250, // fallback for safety
        }}
      >
        {/* Status Pie Chart */}
        <Box
          sx={{
            width: 213,
            height: 213,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ResponsivePie
            data={ConnectionData}
            innerRadius={0.78}
            colors={{ datum: "data.color" }}
            borderWidth={1}
            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
            enableArcLinkLabels={false}
            enableArcLabels={false}
            arcLabelsTextColor="#000"
            onClick={(node, e) => handlePieDeviceStatusChartClick({ node, event: e })}
            layers={[
              "arcs",
              "arcLabels",
              "legends",
              (props) => (
                <text
                  x={props.centerX}
                  y={props.centerY - 15}
                  textAnchor="middle"
                  onClick={() => handleClick("")}
                  dominantBaseline="central"
                  style={{
                    fontSize: 26,
                    fontWeight: "700",
                    fontFamily: "VerizonNHGDS",
                    fill: "#000",
                  }}
                >
                  {deviceCounts.total}
                  <tspan
                    x={props.centerX}
                    y={props.centerY + 12}
                    fontSize="17"
                    fontWeight="400"
                    fontFamily="VerizonNHGDS"
                    fill="#000"
                  >
                    Total Devices
                  </tspan>
                </text>
              ),
            ]}
          />
        </Box>

        {/* Status List */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {[
            { label: "Online Devices", count: deviceCounts.online, color: "#AAD8F9", filter: "Online" },
            { label: "Offline Devices", count: deviceCounts.offline, color: "#FF8027", filter: "Offline" },
          ].map(({ label, count, color, filter }) => (
            <Box
              key={label}
              onClick={() => count > 0 && handleConnectFilterChange(filter)}
              className="alarm-new-container-online"
              sx={{
                pointerEvents: count === 0 ? "none" : "auto",
                cursor: "pointer",
                borderLeft: `6px solid ${color}`,
                p: 0.75,
                backgroundColor: "#fff",
                minWidth: 180,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                minHeight: 60,
              }}
            >
              <Typography className="device-card-title">{label}</Typography>
              <Box
                className="alert-count-val"
                sx={{
                  minHeight: 24,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {!isLoading ? <Typography>{count}</Typography> : <CircularProgress size={20} />}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  </Grid2>

  {/* Device Severity Card */}
  <Grid2 item xs={12} md={6}>
    <Card
      elevation={3}
      sx={{
        backgroundColor: "#FFFFFF",
        padding: 3,
        borderRadius: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 420,
      }}
    >
      <Typography variant="h6" className="font-face-vzw-alert" sx={{ marginBottom: 2, paddingTop: 1 }}>
        DEVICE SEVERITY
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 15,
          height: 250, // fixed height to align with other card
          minHeight: 250,
        }}
      >
        {/* Severity Pie Chart */}
        <Box
          sx={{
            width: 213,
            height: 213,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ResponsivePie
            data={statusData}
            innerRadius={0.78}
            colors={{ datum: "data.color" }}
            borderWidth={1}
            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
            enableArcLinkLabels={false}
            enableArcLabels={false}
            arcLabelsTextColor="#000"
            onClick={(node, e) => handlePieChartClick({ node, event: e })}
            layers={[
              "arcs",
              "arcLabels",
              "legends",
              (props) => (
                <text
                  x={props.centerX}
                  y={props.centerY - 15}
                  textAnchor="middle"
                  onClick={() => handleClick("")}
                  dominantBaseline="central"
                  style={{
                    fontSize: 26,
                    fontWeight: "700",
                    fontFamily: "VerizonNHGDS",
                    fill: "#000",
                  }}
                >
                  {deviceCounts.total}
                  <tspan
                    x={props.centerX}
                    y={props.centerY + 12}
                    fontSize="17"
                    fontWeight="400"
                    fontFamily="VerizonNHGDS"
                    fill="#000"
                  >
                    Total Devices
                  </tspan>
                </text>
              ),
            ]}
          />
        </Box>

        {/* Severity List */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {[
            { label: "Critical Devices", count: deviceCounts.error, color: "#FF8027", filter: "Critical" },
            { label: "Warning Devices", count: deviceCounts.warning, color: "#FED60E", filter: "Warning" },
            { label: "Notification", count: deviceCounts.notification, color: "#0089EC", filter: "Notification" },
            { label: "No alert", count: deviceCounts.ok, color: "#63D48E", filter: "Ok" },
          ].map(({ label, count, color, filter }) => (
            <Box
              key={label}
              onClick={() => count > 0 && handleHealthStatusFilterChange(filter)}
              className="alarm-new-container-online"
              sx={{
                pointerEvents: count === 0 ? "none" : "auto",
                cursor: "pointer",
                borderLeft: `6px solid ${color}`,
                p: 0.75,
                backgroundColor: "#fff",
                minWidth: 180,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                minHeight: 60,
              }}
            >
              <Typography className="device-card-title">{label}</Typography>
              <Box
                className="alert-count-val"
                sx={{
                  minHeight: 24,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {!isLoading ? <Typography>{count}</Typography> : <CircularProgress size={20} />}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  </Grid2>
  <CreateDevice
        // opHeaderText={selectedAsset?.opHeaderText}
        formData={formdata}
        notification={notification}
        open={isOpen}
        onConfirm={() => {}}
        onExit={() => 
          onExit()
        }
      />
  {/* Device List Section */}
  <Grid2 item xs={12}>
    <DeviceList
      permissions={user?.role?.permissions}
      setFilteredData={setFilteredData}
      filteredData={filteredData}
      assetTypeFilter={assetTypeFilter}
      setAssetTypeFilter={setAssetTypeFilter}
      setConnectFilter={setConnectFilter}
      connectFilter={connectFilter}
    />
  </Grid2>
</Grid2>
 </Box>


  );
};

export default DevicesData;